import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/exitFocus.tsx
var ExitFocus = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M20 9h-4a1 1 0 0 1-1-1V4m.5 4.5L20 4m-5 16v-4a1 1 0 0 1 1-1h4m-4.5.5L20 20M4 15h4a1 1 0 0 1 1 1v4m-.5-4.5L4 20M9 4v4a1 1 0 0 1-1 1H4m4.5-.5L4 4",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.75 9a.75.75 0 0 1-.75.75h-4A1.75 1.75 0 0 1 14.25 8V4a.75.75 0 0 1 1.5 0v3.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-3.72 3.72H20a.75.75 0 0 1 .75.75",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15 20.75a.75.75 0 0 1-.75-.75v-4c0-.966.784-1.75 1.75-1.75h4a.75.75 0 1 1 0 1.5h-3.19l3.72 3.72a.75.75 0 1 1-1.06 1.06l-3.72-3.72V20a.75.75 0 0 1-.75.75",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.25 15a.75.75 0 0 1 .75-.75h4c.967 0 1.75.784 1.75 1.75v4a.75.75 0 0 1-1.5 0v-3.19l-3.72 3.72a.75.75 0 0 1-1.06-1.06l3.72-3.72H4a.75.75 0 0 1-.75-.75",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 3.25a.75.75 0 0 1 .75.75v4A1.75 1.75 0 0 1 8 9.75H4a.75.75 0 0 1 0-1.5h3.189l-3.72-3.72a.75.75 0 0 1 1.06-1.06l3.72 3.72V4A.75.75 0 0 1 9 3.25",
			fill: "currentColor"
		})
	] })
});
//#endregion
export { ExitFocus };
